import { GlIcon, GlLink, GlTooltipDirective } from '@gitlab/ui';
import IterationTitle from 'ee/iterations/components/iteration_title.vue';
import { getIterationPeriod, groupOptionsByIterationCadences } from 'ee/iterations/utils';
import { TYPE_ISSUE } from '~/issues/constants';
import { IssuableAttributeType } from '../../constants';
import SidebarDropdownWidget from '../sidebar_dropdown_widget.vue';
export default {
    name: 'SidebarIterationWidget',
    issuableAttribute: IssuableAttributeType.Iteration,
    components: {
        GlIcon,
        GlLink,
        SidebarDropdownWidget,
        IterationTitle
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    props: {
        attrWorkspacePath: {
            required: true,
            type: String
        },
        iid: {
            required: true,
            type: String
        },
        issuableType: {
            type: String,
            required: true,
            validator (value) {
                return value === TYPE_ISSUE;
            }
        },
        workspacePath: {
            required: true,
            type: String
        }
    },
    emits: [
        'iteration-updated'
    ],
    methods: {
        getCadenceTitle (currentIteration) {
            return currentIteration?.iterationCadence?.title;
        },
        groupOptionsByIterationCadences,
        getIterationPeriod
    }
};
